<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { useAuthStore } from '~/stores/auth'

const router = useRouter()
const authStore = useAuthStore()

function goToRegister() {
  router.push('/daftar')
}
</script>

<template>
  <section class="blueGradient">
    <div class="container mx-auto py-[59px] flex flex-col md:flex-row justify-between items-center px-4">
      <h2 class="text-white font-medium text-[32px] md:text-[42px] text-center md:text-left">
        Ready to explore
        <br class="hidden md:block">
        with Rintisan Billing?
      </h2>
      <ClientOnly>
        <Button
          v-if="!authStore.isAuthenticated"
          class="text-[#024CB7] text-lg font-semibold bg-white hover:bg-neutral-100 rounded-md py-4 px-8 mx-auto mt-6 md:mx-0 md:mt-0 h-auto"
          @click="goToRegister"
        >
          Coba Sekarang
        </Button>
      </ClientOnly>
    </div>
  </section>
</template>

<style scoped>
.blueGradient {
  background: linear-gradient(
    106deg,
    #6790ea 1.92%,
    rgba(103, 144, 234, 0.84) 37.61%,
    rgba(103, 144, 234, 0.63) 75.15%,
    rgba(103, 144, 234, 0.49) 102.12%
  );
}
</style>
